import React, { FC } from "react";
import classNames from "classnames";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import { Icons } from "../../SvgIcon/types";

type RichTextAreaProps = {
	content: string | null | undefined;
	className?: string;
	innerClassName?: string;
	icon?: Icons;
    small?: boolean;
};

export const RichTextArea: FC<RichTextAreaProps> = ({
	content,
	className,
	innerClassName = "",
	icon,
    small
}) => {
	return (
		<div
			className={classNames(
				"RichTextArea",
				icon && "RichTextArea--withIcon",
                {"RichTextArea--small": small},
				className
			)}
		>
			{icon && <SvgIcon iconName="info" className="RichTextArea__icon" />}
			<div
				className={classNames("RichTextArea__content", innerClassName)}
				dangerouslySetInnerHTML={{ __html: content ?? "" }}
			/>
		</div>
	);
};
